import { ApplicationInsights } from "@microsoft/applicationinsights-web";

let appInsights: ApplicationInsights | null = null;

export function initAppInsights(connectionString: string): void {
  if (appInsights) {
    return; // already initialized
  }

  appInsights = new ApplicationInsights({
    config: {
      connectionString,
      enableAutoRouteTracking: true,
    },
  });

  appInsights.loadAppInsights();
}

export function getAppInsights(): ApplicationInsights {
  if (!appInsights) {
    throw new Error(
      "Application Insights not initialized. Call initAppInsights() first."
    );
  }
  return appInsights;
}
